/* Kalós homepage — scroll reveal + FAQ accordion + ticker duplication */
(function () {
  if (window.kalosHomeInit) return;
  window.kalosHomeInit = true;

  var initReveal = function () {
    var targets = document.querySelectorAll('.k-sr');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('k-v'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('k-v');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    targets.forEach(function (el) { io.observe(el); });
  };

  var initFaq = function () {
    document.querySelectorAll('.k-faq-item').forEach(function (item) {
      var q = item.querySelector('.k-faq-q');
      var panel = item.querySelector('.k-faq-a');
      if (!q || !panel || q.dataset.bound) return;
      q.dataset.bound = 'true';
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('k-open');
        document.querySelectorAll('.k-faq-item.k-open').forEach(function (other) {
          if (other !== item) {
            other.classList.remove('k-open');
            other.querySelector('.k-faq-a').style.maxHeight = null;
          }
        });
        if (isOpen) {
          item.classList.remove('k-open');
          panel.style.maxHeight = null;
        } else {
          item.classList.add('k-open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initFaq();
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initReveal();
    initFaq();
  }
})();
